import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useFetchBreakSettings } from 'modules/attendance/hooks/useFetchBreakSettings'
import { useFetchTimeSettingsBreakConfigurations } from 'modules/attendance/hooks/useFetchTimeSettingsBreakConfigurations'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import Breaks from './Breaks'

interface Props {
  attendanceSetting: AttendanceSetting
}

const PolicyBreaks = ({ attendanceSetting }: Props) => {
  const {
    loading: loadingBreakSetting,
    breakSettings,
    refetch: refetchBreakSettings,
  } = useFetchBreakSettings([attendanceSetting?.id])

  const {
    loading: loadingBreakConfigurations,
    timeSettingsBreakConfigurations,
    refetch: refetchBreakConfigurations,
  } = useFetchTimeSettingsBreakConfigurations(attendanceSetting.id)

  if (loadingBreakSetting || loadingBreakConfigurations)
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  const refetch = () => {
    attendanceSetting.fetch()
    refetchBreakSettings()
    refetchBreakConfigurations()
  }

  return (
    <Breaks
      attendanceSetting={attendanceSetting}
      breakSettings={breakSettings}
      timeSettingsBreakConfigurations={timeSettingsBreakConfigurations}
      refetch={refetch}
    />
  )
}

export default observer(PolicyBreaks)
